import React from "react";
import Headers from "../Header/Header";
import "./terms.css";
const Terms = () => {
  return (
    <div>
      <Headers />
      <div className="terms-box">
        <div className="row align-items-center mb-3">
          <div className="col-3 terms-title">قوانین و مقررات</div>
          <div className="col-9 terms-text">
            <p>
              کاربر گرامی، ضمن تشکر از انتخاب سایت و اپلیکیشن"کجا نجف آباد"،
              عضویت شما به معنای تایید قوانین بوده و گام برداشتن براساس قوانین
              باعث پایداری بیشتر ما و ارائه خدمات بهتر خواهد بود. از آنجا که
              استفاده یا عضویت از این سایت یا اپلیکیشن به هر شکل به معنای قبول
              شرایط مندرج در بخش قوانین "کجا نجف آباد" است، لذا کاربر موظف است
              قبل از هر گونه ثبت سفارش، این قوانین را به دقت مطالعه کرده و در
              صورتیکه با آنها موافق است، سفارش خود را ثبت نماید. شایان ذکر است
              شرایط و قوانین جدید مندرج در این بخش، همواره جایگزین کلیه مندرجات
              گذشته محسوب می‌شوند. در صورتی که در آینده تغییراتی در قوانین
              مندرج، رویه‏‌ها و سرویس‏‌های "کجا نجف آباد" ایجاد شود، در همین
              صفحه منتشر و به روز رسانی خواهد شد و شما توافق می‏‌کنید که استفاده
              مستمر شما از سایت یا اپلیکیشن به معنی پذیرش هرگونه تغییر است.
            </p>
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-3 terms-title">تعاریف واژگان</div>
          <div className="col-9 terms-text">
            <p>
              در این قسمت با واژه هایی که در متن قوانین ما مورد استفاده قرار می
              گیرند، بیشتر آشنا خواهیم شد. "کجا نجف آباد": سایت و اپلیکیشن"کجا
              نجف آباد" که یک پلتفرم ارائه خدمات تعیین قیمت املاک توسط کارشناسان
              دارای مجورز در سطح شهر محل زندگی مشتری می‌باشد. سایت: وب سایت و
              اپلیکیشن "کجا نجف آباد" به آدرس www.koja-najafabad.ir اپلیکیشن:
              منظور اپلیکیشن ثبت شده "کجا نجف آباد" می‌باشد. محتوای سایت و
              اپلیکیشن: شامل نام، ساعت فعالیت، تصویر، نام دفاتر و آدرس کارشناسان
              یا کلیه مقالات و اخبار درج شده در سایت و اپلیکیشن می باشد. کارشناس
              یا کارشناسان: کارشناسی که کاربر در بستر سایت و اپلیکیشن "کجا نجف
              آباد" برای کارشناسی ملک خود انتخاب کرده است. کاربر: هر فردی که از
              طریق اینترنت وارد سایت یا اپلیکیشن "کجا نجف آباد" شده باشد، کاربر
              تلقی می شود. عضو: کاربری که به عضویت اولیه یا کامل سایت یا
              اپلیکیشن درآمده باشد، عضو تلقی می شود. مشتری: کاربر یا عضوی که از
              سایت یا اپلیکیشن درخواست کارشناسی ثبت می نماید. نوبت: زمان تعیین
              شده توسط بستر به صورت خودکار برای بررسی محیطی ملک مورد نظر توسط
              کارشناس.
            </p>
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-3 terms-title">سفارش</div>
          <div className="col-9 terms-text">
            <p>
              از نظر حقوقی، در معاملات سایت و اپلیکیشن "کجا نجف آباد"، کارشناس
              یا کارشناسانی که کاربر در بستر سایت و اپلیکیشن "کجا نجف آباد" برای
              کارشناسی انتخاب کرده است، عنوان ارائه دهند خدمات، و کاربر اینترنتی
              سفارش دهنده به عنوان دریافت کننده خدمات تلقی می شوند و سایت و
              اپلیکیشن "کجا نجف آباد" صرفا به عنوان پلتفرم تعیین نوبت کارشناسی
              محسوب می‌گردد. مشابه محیط فیزیکی، در محیط الکترونیکی نیز هر گونه
              داد و ستدی که انجام می گیرد، نشان دهنده وقوع یک عقد یا قرارداد می
              باشد. عقد یا قرارداد مطابق ماده 183 قانون مدنی عبارتست از اینکه "
              یک یا چند نفر در مقابل یک یا چند نفر دیگر تعهد بر امری نمایند و
              مورد قبول آنها باشد " ؛ بر همین اساس قرارداد آنلاین نیز قراردادی
              است که از طریق "داده پیام" منعقد می گردد.
            </p>
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-3 terms-title">سامانه پیامکی و ارتباطی</div>
          <div className="col-9 terms-text">
            <p>
              سامانه پیامکی 3000606 به منظور ارسال پیامک از سامانه "کجا نجف
              آباد" به شما در نظر گرفته شده است و این سایت و اپلیکیشن هیچگونه
              تعهدی نسبت به پیامک‌هایی که از سایر سامانه‌ها تحت عنوان "کجا نجف
              آباد"به شما ارسال میشوند ندارد. لطفا در صورت دریافت هرگونه پیامکی
              به غیر از این سامانه آن را از طریق پست الکترونیکی
              info@koja-najafabad.ir به اطلاع ما برسانید . همچنین این شماره،‌‌
              سامانه ارسال پیامک است که وضعیت پردازش سفارش یا رویدادها، خدمات و
              سرویس‌های ویژه "کجا نجف آباد" را به اطلاع کاربران می‌رساند و روشن
              است که امکان دریافت پیام‌های شما از طریق آن وجود ندارد. ارتباط با
              امور مشتریان "کجا نجف آباد"، از طریق شماره تلفن‌ پشتیبانی یا از
              طریق فرم صفحه "تماس با ما" و یا ایمیل info@koja-najafabad.ir
              مقدورخواهد بود ، همچنین میتوانید پیشنهادات و انتقادات خود را مطرح
              کنید.
            </p>
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-3 terms-title">روش های پرداخت </div>
          <div className="col-9 terms-text">
            <p>
              تمای پرداخت های داخل سایت و اپلیکیشن به بصورت آنلاین (درگاه پرداخت
              اینترنتی) می باشد و مابقی پرداخت ها به هر نحوی فاقد اعتبار و کم لم
              یکن تلقی می گردد. امکان خطا در قیمت های سایت "کجا نجف آباد" همواره
              سعی می نماید که نرخ کارشناسی ها به درستی و حداقل میزان خطا در سایت
              وارد نماید. اما از آنجایی که "کجا نجف آباد" یک بستر چند کارشناسی
              است و وارد کردن قیمت ها توسط کارشناسان انجام می شود، همواره امکان
              وجود خطای انسانی در ورود اطلاعات هست. لذا در مواقعی که قیمت ها به
              اشتباه وارد سایت شده باشند، این امر هیچگونه تعهدی برای “کجا نجف
              آباد” در قبال ارائه خدمت به همان قیمت اشتباه ایجاد نخواهد کرد. در
              این موارد حتی چنانچه بر اساس قیمت اشتباه، نتیجه کارشناسی برای
              مشتری ارسال گردد، مشتری موظف است ما به التفاوت وجه را به حساب “کجا
              نجف آباد” واریز نماید. مشتری با قبول قوانین سایت، حق هر گونه
              اعتراض در این موارد را از خود سلب می نماید.
            </p>
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-3 terms-title">نتیجه کارشناسی</div>
          <div className="col-9 terms-text">
            <p>
              تمای نتایج کارشناسی ارائه شده در بستر کجا نجف آباد، صرفا نظر
              کارشناس مربوطه در مورد ملک مشتری بوده و کجا نجف آباد هیچ مسئولیت و
              دخل و تصرفی در مورد این نتایح ندارد (نحوه قیمت گذاری و محاسبات و
              ...). لذا کاربر و مشتری حق هر گونه اعتراض را نسبت به این موارد از
              خود سلب می نماید.
            </p>
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-3 terms-title">محتوا</div>
          <div className="col-9 terms-text">
            <p>
              همه موارد موجود در"کجا نجف آباد" اعم از کلیه صفحات، تصاویر، موارد
              قابل ذخیره‌سازی، داده ها، خدمات، متن، آرم دکمه، گرافیک، آرم،
              آیکون، موارد قابل دانلود و کپی و کلیه محتوای موجود جزئی از
              اموال"کجا نجف آباد" محسوب می‌ شود و حق استفاده و انتشار رسمی آنها
              در انحصار "کجا نجف آباد"می‌باشد. هر گونه استفاده بدون اخذ مجوز
              کتبی، حق پیگرد قانونی برای"کجا نجف آباد"را محفوظ می دارد. کلیه
              حقوق سایت"کجا نجف آباد" شامل قوانین حق تکثیر و غیره به این سایت
              تعلق دارد. کلیه محتوای سایت صرفاً متعلق به "کجا نجف آباد" بوده و
              هرگونه کپی برداری و استفاده شخصی یا تجاری از آن بدون کسب مجوز
              مکتوب از “کجا نجف آباد” غیر مجاز و پیگرد قانونی به همراه خواهد
              داشت. کاربران مجاز به بهره‌‏برداری و استفاده از لیست محصولات،
              مشخصات، قیمت و هر گونه استفاده از مشتقات وب‏‌سایت"کجا نجف آباد"و
              یا هر یک از خدمات و یا مطالب، دانلود یا کپی کردن اطلاعات با مقاصد
              تجاری، هر گونه استفاده از داده کاوی، ربات، یا روش‌‏های مشابه مانند
              جمع آوری داده‌‏ها و ابزارهای استخراج نیستند و کلیه این حقوق برای
              "کجا نجف آباد"محفوظ است. "کجا نجف آباد" حداکثر تلاش خود را برای
              درج اطلاعات صحیح (از جمله قیمت، اطلاعات فنی، عکس کالاها و مقالات)
              به کار می گیرد، با این حال درست بودن تمامی مطالب و بدون نقص بودن
              محتوای اطلاعات خود را تضمین نمی نماید.
            </p>
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-3 terms-title">تبلیغات و فروش</div>
          <div className="col-9 terms-text">
            <p>
              تبلیغات “کجا نجف آباد” در چهارچوب کلیه قوانین و مقررات جمهوری
              اسلامی ایران به ویژه ماده 2 آیین نامه اجرایی ماده 7 قانون حمایت از
              حقوق مصرف کنندگان، و مواد 50 الی 55 قانون تجارت الکترونیک صورت می
              گیرد. کلیه ی مشتریان جهت آگاهی از آخرین اخبار و اطلاعات “کجا نجف
              آباد” و همچنین آگاهی از تخفیفات و موارد دیگر اجازه ی ارتباط از
              طریق پیامک ایمیل و مرسولات کاغذی را به “کجا نجف آباد” می دهند. جهت
              اطلاع رسانی رویدادها، خدمات و سرویس‌های ویژه یا پروموشن‌ها، امکان
              دارد "کجا نجف آباد"برای کاربران ایمیل یا پیامک ارسال نماید.
            </p>
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-3 terms-title">خطاهای انسانی و سیستمی</div>
          <div className="col-9 terms-text">
            <p>
              با توجه به اینکه امکان بروز خطا به شکل های مختلف اعم از خطاهای
              نمایش نتیجه کارشناسی، ثبت اعداد اشتباه توسط کارشناس و .... وجود
              دارد. پلتفرم کجا نجف آباد مسئولیتی در قبال این اشتباهات ندارد و
              صرفا متعهد می گردد که پس از مطلع شدن از وجود این خطاها نسبت به رفع
              آنها اقدام نماید. نقدها و نظرات و مطالب بارگذاری شده توسط اشخاص 1-
              نظرات ، پیشنهادات و انتقادات پس از تایید ناظران در بخشی از سایت و
              اپلیکیشن قرار خواهند گرفت. اگر مطالب مطابق با قوانین و شئونات
              نباشند، تایید نشده و به نمایش گذاشته نخواهند شد. “کجا نجف آباد” در
              نشر یا عدم نشر نظرات کاربران دارای اختیار کامل می باشد. 2-
              خواهشمند است نظرات سایر کاربران را اصل و پایه انتخاب خود قرار
              نداده و در انتخاب و تصمیم‌گیری‌های خود تنها به عنوان یک نظر شخصی
              به آنها بنگرید. در صورت مشاهده نظرات مخالف قوانین و شئونات اسلامی،
              لطفا یک ایمیل جهت پیگیری و اصلاح به پست الکترونیکی "کجا نجف
              آباد"به آدرس info@koja-najafabad.ir ارسال نمایید. ارسال پست ها
              صرفا بیانگر نظر و عقیده نویسنده‌ی آن بوده و بیانگر نظر و عقیده
              مسئولان سایت نمی‌باشد. 3-کاربران باید در انتخاب عکس پروفایل خود
              دقت کنند و از گذاشتن عکس های با پوشش نامناسب و مخالف با قوانین
              جمهوری اسلامی ایران خودداری کنند. از گذاشتن شماره موبایل یا شماره
              تلفن ثابت به جای نام کاربری یا اسم کاربری خودداری کنید. 4-قراردادن
              هرگونه محتوای مغایر با شئونات نظام جمهوری اسلامی توسط کاربر، تخلف
              به حساب می آید. 5-کپی کردن مطالب کاربران، خلاف قوانین سایت می باشد
              و در صورت اثبات این موضوع با کاربر برخورد میشود. 6-بکار بردن اسامی
              شامل مدیر، مدیر سایت، مدیر"کجا نجف آباد"، پلیس"کجا نجف آباد"،
              پشتیبانی "کجا نجف آباد" و امثال این اسامی منتسب به "کجا نجف آباد"
              چه به زبان فارسی و چه به زبان انگلیسی خلاف می باشد و با کاربر مورد
              نظر برخورد خواهد شد. 7-کلیه فعالیت هایی که همراه با انتشار ویروس،
              تروجان یا هرگونه برنامه ی مخرب دیگر باشند تخلف به حساب می آیند.
              8-حق ارسال ایمیل توسط "کجا نجف آباد" برای کاربران خود همواره محفوظ
              است. 9-کاربران موظفند طبق قوانین "کجا نجف آباد" و قوانین مربوط به
              جرائم رایانه ای فعالیت نموده و مدیران را از هرگونه ارسال خلاف
              قوانین مطلع سازند. 10-هرگونه توهین به مقامات کشوری یا مقدسات
              جمهوری اسلامی ایران ممنوع بوده و با کاربر خاطی برخورد حقوقی می
              شود. 11-هرگونه سوء استفاده از اطلاعات کاربران، عکسها و مشخصات آنها
              ممنوع می باشد. 12-تبلیغ و دعوت به شبکه های اجتماعی دیگر یا چت روم
              ها یا انجمن های گفت وگو و سایت های کسب درآمد ممنوع می باشد.
              13-هرگونه امور تبلیغاتی در فضای سایت ممنوع بوده و جهت امور
              تبلیغاتی باید با مدیریت سایت هماهنگی شود. 14-در وبسایت، امکان بحث
              و تبادل نظر با سایر کاربران، ثبت نظرات، پیشنهادات و سؤالات فراهم
              شده است. کاربران موظف هستند از درج هرگونه مطالب مغایر با اصول
              قانونی و اخلاقی، افترا آمیز، تهدید کننده حریم خصوصی افراد یا حقوق
              مالکیت معنوی و هرگونه مطالب ناشایست دیگر جداً خودداری نمایند، در
              غیراینصورت کلیه مسئولیت و عواقب قانونی آن بر عهده ایشان می باشد و
              در صورتیکه کاربری نسبت به رعایت و ضوابط “کجا نجف آباد” در درج
              نظرات توجه کافی نداشته باشد، “کجا نجف آباد” مجاز است از دسترسی
              مجدد کاربر به سایت جلوگیری به عمل آورده و در صورت لزوم وی را تحت
              پیگرد قانونی قرار دهد. 15-حذف کاربری در "کجا نجف آباد" باعث حذف
              کامل کاربر نمی شود، فقط باعث غیر فعال شدن حساب کاربری و عدم نمایش
              پروفایل کاربر به دیگران میشود. برای حذف کردن حساب کاربری بصورت
              کامل باید از طریق پیشنهادات و انتقادات با مدیریت سایت هماهنگ شود .
              16-هر گونه استفاده غیر متعارف، غیر مجاز و غیر قانونی از سایت توسط
              کاربران که منجر به آسیب، خرابی، از دست رفتن یا تغییر اطلاعات،
              افشای اطلاعات شخصی کاربران و سایر ضرر و زیان های احتمالی گردد،
              پیگرد قانونی به دنبال خواهد داشت. 17-کاربران موظف به حفاظت از
              اطلاعات شخصی کاربری خویش بوده و مسئولیت تبادل هرگونه اطلاعاتی که
              از طریق شناسه کاربری و رمز عبور آن ها صورت می گیرد بر عهده آنان
              است. 18-”کجا نجف آباد” در قبال افشای اطلاعات کاربر در اثر قصور و
              یا ویروسی شدن سیستم کامپیوتری وی مسئولیتی نخواهد داشت. 19-پرسش و
              پاسخ کوتاه و مختصر اما مفید بسیار کارآمد است؛ لطفا زبان و خط فارسی
              و اسلوب نگارش را در نوشتار رعایت کنید. از کیبورد فارسی استفاده
              کنید. از کشیدن حروف یا کلمات و استفاده‌ی مکرر از یک حرف یا کلمه
              خودداری کنید. 20-لطفا در بخش پرسش و پاسخ در مورد "قیمت" نپرسید.
              برای اطلاع از قیمت به آسانی و با جستجوی نام کالا به آن دسترسی
              دارید. 21-از درج آدرس سایر فروشگاههای فیزیکی و یا اینترنتی و
              استفاده از لینک جدا خودداری کنید. 22-با ذکر پرسش خود تنها یک بار
              در زیر محصول موردنظر اطمینان حاصل کنید که باقی کاربران آن را
              خواهند دید و از تکرار مجدد آن خودداری کنید 23-از ثبت اطلاعات شخصی
              مانند ایمیل، شماره تماس و نام کاربری شبکه های اجتماعی در بخش پرسش
              و پاسخ جدا بپرهیزید. رعایت حریم شخصی اطلاعاتی که کاربران در
              اختیار" کجا نجف آباد" قرار می‌دهند مورد احترام است و از آن محافظت
              می شود. این سامانه در حد توان از حریم شخصی کاربران دفاع کرده و با
              بهره‌مندی از تکنولوژی های جدید، جهت توسعه امنیت در سایت در راستای
              رضایتمندی کاربران می‌کوشد. بدین منظور اطلاعاتی‌ که از کاربران برای
              ثبت نام دریافت میشود به هیچ عنوان در اختیار شخص یا سازمانی قرار
              نخواهد گرفت و کاملا محرمانه است. آدرس ایمیل و تلفن‌هایی که مشتری
              در پروفایل خود ثبت می‌کند، تنها آدرس ایمیل و تلفن‌های رسمی و مورد
              تایید مشتری است و تمام مکاتبات و پاسخ‌های شرکت از طریق آنها صورت
              می‌گیرد. افراد زیر 18 سال که تمایل به ثبت درخواست از “کجا نجف
              آباد” دارند، باید با اطلاع والدین و یا قیم قانونی، نسبت به پرداخت
              اقدام کنند.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
